import {
  statRoundsFirstRate,
  statRoundsAfPercentile,
  statRoundsLastRate,
} from "../RoundStats";
import {
  TrackRound,
  getDriverTimesWithLastPos,
} from "model/Match/Track/TrackRound";
import { statTimesDnfRate } from "stats/TimeStats";

export type SharedDriverTournamentStats = {
  orgId: string | undefined;
  orgName: string | undefined;
  driverName: string;
  driverRating: number | undefined;
  averageFinishPercentile: number | undefined;
  firstRate: { rate: number | undefined; breakdown: string };
  lastRate: { rate: number | undefined; breakdown: string };
  dnfRate: { rate: number | undefined; breakdown: string };
};

export const getSharedDriverTournamentStats = (
  driverId: string,
  orgId: string | undefined,
  orgName: string | undefined,
  driverName: string,
  driverRating: number | undefined,
  rounds: TrackRound[]
): SharedDriverTournamentStats => {
  const roundTimesWithLastPos = getDriverTimesWithLastPos(rounds, driverId);
  const roundTimes = roundTimesWithLastPos.map((r) => r.time);

  return {
    orgId,
    orgName,
    driverName,
    driverRating,
    averageFinishPercentile: statRoundsAfPercentile(roundTimesWithLastPos),
    firstRate: statRoundsFirstRate(roundTimes),
    lastRate: statRoundsLastRate(roundTimesWithLastPos),
    dnfRate: statTimesDnfRate(roundTimes),
  };
};
